import { useTranslation } from "react-i18next";

import "modules/AppointmentDetails/components/CustomerCommunicationModal/components/CustomerCommunicationPrice/CustomerCommunicationPrice.scss";
import { formatPrice } from "utils/formatPrice";

import type { Totals } from "utils/common";

interface CustomerCommunicationPriceProps {
  totals: Totals;
  showVat?: boolean;
}

export const CustomerCommunicationPrice = ({ totals, showVat }: CustomerCommunicationPriceProps) => {
  const { t } = useTranslation();

  return (
    <div className="total-amount-container">
      {showVat &&
        totals.vatGroups.length > 0 &&
        totals.vatGroups
          .filter(group => group.rate > 0 && group.amount > 0)
          .map(group => (
            <div key={group.rate} className="float-right">
              <p>
                {t("v8_vat", "VAT")} {group.rate}%: <strong>€ {formatPrice(group.amount)}</strong>
              </p>
            </div>
          ))}
      <div className="float-right">
        <p>
          {t("v8_total_amount_of_selected_items", "Total amount of selected items")}: <strong>€ {formatPrice(totals.totalAmount)}</strong>
        </p>
      </div>
    </div>
  );
};
